import { useClientContractTermDetail } from './hooks';
import { convertToPresentationProps } from './logics';
import { ClientContractTermDetailPresentation } from './presentations';

type Props = {
  /** 利用企業 ID（Screen 層でパース・検証済みの数値） */
  clientId: number;
  /** 企業契約期間 ID（Screen 層でパース・検証済みの数値） */
  termId: number;
};

/**
 * 企業契約期間 詳細 Container
 *
 * @param clientId - 利用企業 ID（Screen 層でパース・検証済みの数値）
 * @param termId - 企業契約期間 ID（Screen 層でパース・検証済みの数値）
 *
 * ## 注意
 * - Suspense（`suspense: true`）でデータ取得を行うため、エラー時は ErrorBoundary に委譲される
 */
export const ClientContractTermDetail: React.FC<Props> = ({ clientId, termId }) => {
  const {
    state: { data },
  } = useClientContractTermDetail({ clientId, termId });

  const {
    clientName,
    editLink,
    contractPlanName,
    contractPlanLink,
    startedOnLabel,
    endedOnLabel,
    createdAtLabel,
    updatedAtLabel,
  } = convertToPresentationProps({ data });

  return (
    <ClientContractTermDetailPresentation
      clientName={clientName}
      editLink={editLink}
      contractPlanName={contractPlanName}
      contractPlanLink={contractPlanLink}
      startedOnLabel={startedOnLabel}
      endedOnLabel={endedOnLabel}
      createdAtLabel={createdAtLabel}
      updatedAtLabel={updatedAtLabel}
    />
  );
};
